import styled from "styled-components";
import { layout, space } from "styled-system";

export const GridRow = styled.div`
  ${layout};
  ${space};

  display: none;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 20px;
  margin-right: 48px;
  margin-left: 48px;

  ${({ mobile }) =>
    mobile && typeof mobile === "number"
      ? `
          display: grid;
          grid-template-columns: repeat(${mobile}, 1fr);
          max-width: auto;
          min-width: auto;
          margin-right: 0;
          margin-left: 0;
    `
      : `
          display: grid;
      `}

  @media ${"only screen and (min-width: 768px)"} {
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 20px;
    margin-right: 64px;
    margin-left: 64px;
    ${({ tablet }) =>
      tablet && typeof tablet === "number"
        ? `
            display: grid;
            grid-template-columns: repeat(${tablet}, 1fr);
            max-width: auto;
            min-width: auto;
            margin-right: 0;
            margin-left: 0;
      `
        : `
            display: grid;  
        `}
  }

  @media ${"only screen and (min-width: 1024px)"} {
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 20px;
    margin-right: 48px;
    margin-left: 48px;
    max-width: 1152px;
    min-width: 900px;
    ${({ desktop }) =>
      desktop && typeof desktop === "number"
        ? `
            display: grid;
            grid-template-columns: repeat(${desktop}, 1fr);
            max-width: auto;
            min-width: auto;
            margin-right: 0;
            margin-left: 0;
      `
        : `
            display: grid;
        `};
  }

  @media ${"only screen and (min-width: 1280px)"} {
    margin: 0 auto;
  }
`;
